// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1WIo1","options":"AnswerScale_options__6oAeK","selected":"AnswerScale_selected__1Jnzb"};